import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  GlobalMessageService,
  OccEndpointsService
} from '@spartacus/core'
import { Observable } from 'rxjs'
import { MbLogoutAdapter } from '../../adapters/mb-logout.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbOccLogoutAdapter implements MbLogoutAdapter {
  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected globalMessageService: GlobalMessageService) {}

  load (): Observable<any> {
    return this.http
      .get<any>(
          this.getEndpoint()
        )
  }

  protected getEndpoint (): string {
    return this.occEndpoints.buildUrl('logout')
  }
}
